import * as React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Navbar from 'src/components/navbar/Navbar';
import { MIN_WIDTH } from 'src/globals';
import DiscoverRateSearchBar from './DiscoverRateSearchBar';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import Tabs from 'antd/lib/tabs';
import Form, { FormComponentProps } from 'antd/lib/form';
import Select from 'antd/lib/select';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import message from 'antd/lib/message';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import Loader from 'src/components/common/Loader';
import { sortBy, uniqueId } from 'lodash';
import {
  SearchResult,
  FFList,
  FetchedInquiries,
  SearchParams,
  POLPODPairData,
} from './TypesInDiscoverRates/SearchResult';
import IntersectChargeCard from './IntersectChargeCard';
import ColumnViewIntersectChargeCard from './ColumnViewIntersectChargeCard';  
import DiscoverRateSortByPopup from './DiscoverRateSortByPopup';
import DiscoverRatesFilters from './DiscoverRatesFilters';
import { bindActionCreators } from 'redux';
import {
  getAllDataResetFilter,
  setSearchFilterValues,
  getAllDataSetSortByFilter,
  fetchAllData,
  fetchGridData,
  setGridPorts,
  setGridFiltersRange,
  fetchFilters,
  getAllDataSetFilter,
  setSearchResults,
} from 'src/actions/discoverRatesActions';
import { SelectedFilters, SortByFilters } from './TypesInDiscoverRates/SelectedFilters';
import {
  sortByOptions,
  sortByWhenNoLocals,
  isSellRatesContentVisible,
  gridPortCodeList,
  GridView,
  savedInLocalStorage,
  setSavedArray,
  DiscoverRatesViews
} from './DiscoverRateUtils';
import { isValidArray, isValidString, equal } from 'src/Library/Helper';
import {
  DISCOVER_SELL_RATES,
  DISCOVER_BUY_RATES,
  DISCOVER_RATES,
  MY_PROFILE,
} from 'src/utils/partsToShow/partsConstants';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { StylesProps, RouterProps } from 'src/Library/Types';
const emptyDiscoverRates = require('src/assets/images/emptyDiscoverRates.png');
import { arrowSvg, DiscoverRatesStyles } from './DiscoverRates.styles';
import { tokens } from 'src/design-system';
import { useDebounce } from 'src/hooks/useDebounce';
import { fetchShippers, renderSelectDropDown } from 'src/Library/Common';
import { fetchAllStakeholdersPaginated } from 'src/api/masters';
import {
  ObjectIdNamePair,
  Currency,
  Carriers,
  Ports,
  PortOrLocation
} from 'src/components/common/Types/CommonTypes';
import {
  getDiscoverRatesRoute,
  getCreateInquiryRoute,
  getDiscoverRatesLandingPageRoute,
} from 'src/routing/utils';
import { arrayToObject , isDemoOrganisation } from 'src/utils/utils';
import classNames from 'classnames';
import { fetchPreviousInquiries } from 'src/api/inquiry';
import InquiryConfirmationModal from './InquiryConfirmationModal';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import PortSettingsSideDrawer from './PortSettingsSideDrawer';
import isEmpty from 'lodash/isEmpty';
import { getPorts } from 'src/api/containerTracking';
import { GridPorts } from './TypesInDiscoverRates/DiscoverRatesCommon';
import GridBox from './GridBox';
import debounce from 'lodash/debounce';
import { InquiryModes, PERMISSON_ERROR_MESSAGE, PortModule, StakeholderTypes, UserRole } from 'src/Library/Constants';
import { fetchRecentSearches, fetchTrendingSearches } from 'src/api/discoverRates';
import RecentOrTrendingCard from './RecentOrTrendingCard';
import SendIcon from 'src/components/common/icons/send';
import { fetchVendorsAndTeams } from '../MarkupAutomationTool/MarkupAutomationTool.common';
import AnalyticsView from './AnalyticsView';
import { ChargeListCardsStyles } from './ChargeListCards.styles';

interface DiscoverRatePageProps
  extends StylesProps<ReturnType<typeof DiscoverRatesStyles>>,
  FormComponentProps,
  RouterProps {
  searchResults: SearchResult[];
  fetchedResultWithFilters: SearchResult[];
  searchFilters: SearchFilters;
  isLoading: boolean;
  selectedFilters: SelectedFilters;
  sortByFilters: SortByFilters;
  isFiltersLoading: boolean;
  getAllDataResetFilter: (apiCall?: boolean, fromURL?: boolean) => void;
  setSearchFilterValues: (val) => void;
  fetchAllData: ({}:{
    isSearch?: boolean;
    resetFreight?: boolean;
    fromURL?: boolean;
    tabChange?: boolean;
    customDataFromQuery?: object;
  }) => {};
  buyRatesViewPermission: boolean;
  sellRatesViewPermission: boolean;
  showDiscoverSellRates: boolean;
  showDiscoverBuyRates: boolean;
  orgType: string;
  userRole: UserRole;
  getAllDataSetFilter: (val: Partial<SelectedFilters>, apiCall?: boolean) => void;
  ffList: FFList[];
  errorMessage: string;
  getAllDataSetSortByFilter: (val, apiCall?: boolean) => void;
  createInquiryPermission: boolean;
  gridPorts: GridPorts;
  portList: Record<string, POLPODPairData>;
  fetchGridData: (isPrimary?: boolean) => void;
  setGridPorts: (val) => void;
  setGridFiltersRange: (val) => void;
  setSearchResults: (val) => void;
  fetchFilters: () => void;
  uuid: string;
  partsToShow: { [key: string]: boolean };
  notificationMasters: [];
  showMarkupCriteria: boolean;
  discoverRatesPrefillData: Record<string, any> | undefined;
  showRoadInsteadDomestic?: boolean;
}

interface StateProps {
  isSortByPopupVisible: boolean;
  searchShipperQuery: string;
  fetchingShippers: boolean;
  linkedShippers: ObjectIdNamePair[];
  activeKey: string;
  isInquiryConfirmationVisible: boolean;
  inquiryData: FetchedInquiries[];
  fetchingCustomisedRates: boolean;
  searchParams?: SearchParams;
  isPortSettingsVisible: boolean;
  gridScrollTop?: number;
  gridScrollLeft?: number;
  recentSearches: SearchParams[];
  trendingSearches: SearchParams[];
  isRecentSearchesLoading: boolean;
  teams: ObjectIdNamePair[];
  mode?: string;
  selectedView: string;
  uniqueKey: string;
  selectedVendorRating: string[];
  searchResultsWithVendorRatingFilter: any;
  isInitial: boolean;
  stakeholderList: Array<{ key: string; label: string }>;
  customerList: Array<{ key: string; label: string }>;
  searchStakeholderQuery: string;
  searchCustomerQuery: string;
  fetchingStakeholders: boolean;
  fetchingCustomers: boolean;
}

const { useState, useEffect } = React;
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const DiscoverRatePage = (props: DiscoverRatePageProps): React.ReactElement => {
  const {
    classes,
    searchResults,
    fetchedResultWithFilters,
    searchFilters,
    isLoading,
    sortByFilters,
    setSearchFilterValues,
    isFiltersLoading,
    selectedFilters,
    form,
    fetchAllData,
    history,
    buyRatesViewPermission,
    sellRatesViewPermission,
    showDiscoverSellRates,
    showDiscoverBuyRates,
    orgType,
    getAllDataResetFilter,
    getAllDataSetFilter,
    ffList,
    errorMessage,
    getAllDataSetSortByFilter,
    createInquiryPermission,
    portList,
    fetchGridData,
    setGridPorts,
    gridPorts,
    setSearchResults,
    setGridFiltersRange,
    fetchFilters,
    location,
    uuid,
    showMarkupCriteria,
    discoverRatesPrefillData,
    showRoadInsteadDomestic
  } = props;

  const { PODList, POLList } = gridPorts;

  const isLandingPage = location.pathname?.includes('discover-rates') && orgType === 'SHIPPER';

  const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
  
  const toggleFilterCollapse = () => {
    setIsFilterCollapsed(!isFilterCollapsed);
  };

  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [selectedRateData, setSelectedRateData] = useState<any>(null);

  const [state, setState] = useState<StateProps>({
    isSortByPopupVisible: false,
    searchShipperQuery: '',
    fetchingShippers: false,
    linkedShippers: [],
    activeKey: showDiscoverBuyRates ? 'BUY' : 'SELL',
    isInquiryConfirmationVisible: false,
    inquiryData: [],
    fetchingCustomisedRates: false,
    searchParams: undefined,
    isPortSettingsVisible: false,
    recentSearches: [],
    trendingSearches: [],
    isRecentSearchesLoading: false,
    teams: [],
    mode: undefined,
    selectedView: DiscoverRatesViews.RATES,
    uniqueKey: uniqueId(),
    selectedVendorRating: [],
    searchResultsWithVendorRatingFilter: [],
    isInitial: true,
    stakeholderList: [],
    customerList: [],
    searchStakeholderQuery: '',
    searchCustomerQuery: '',
    fetchingStakeholders: false,
    fetchingCustomers: false,
  });

  const {
    isSortByPopupVisible,
    searchShipperQuery,
    fetchingShippers,
    linkedShippers,
    activeKey,
    isInquiryConfirmationVisible,
    inquiryData,
    fetchingCustomisedRates,
    searchParams,
    isPortSettingsVisible,
    gridScrollTop,
    gridScrollLeft,
    recentSearches,
    trendingSearches,
    isRecentSearchesLoading,
    teams,
    mode,
    selectedView,
    uniqueKey,
    selectedVendorRating,
    searchResultsWithVendorRatingFilter,
    isInitial,
    stakeholderList,
    customerList,
    searchStakeholderQuery,
    searchCustomerQuery,
    fetchingStakeholders,
    fetchingCustomers,
  } = state;

  const debouncedSearchShipper = useDebounce(searchShipperQuery, 300);
  const debouncedSearchStakeholder = useDebounce(searchStakeholderQuery, 300);
  const debouncedSearchCustomer = useDebounce(searchCustomerQuery, 300);

  const searchedShipper = JSON.parse(localStorage.getItem('searchedShipper') || '{}');

  useEffect(() => {
    uuid && window.localStorage.setItem('searchUUID', uuid);
    setStateUtil({ selectedView: DiscoverRatesViews.RATES})
  }, [uuid]);

  React.useLayoutEffect(() => {
    if (!isInitial) {
      fetchAllData({tabChange: true});
    }
  }, [selectedView])

  const searchUUID = localStorage.getItem('searchUUID');
  const redirectToLandingPage = orgType === 'SHIPPER' && !searchUUID && !discoverRatesPrefillData;
  const query = useQuery();
    
  useEffect(() => {
    if (redirectToLandingPage) {
      history.push(getDiscoverRatesLandingPageRoute());
    }
    const mode = orgType !== 'SHIPPER' ? InquiryModes.FCL : (SavedValues?.[0]?.mode || InquiryModes.FCL)
    setStateUtil({ mode })
    return () => {
      setSearchFilterValues({ view: showDiscoverBuyRates ? 'BUY' : 'SELL' });
    }
  }, []);

  useEffect(() => {
    if (!isLandingPage) {
      searchedShipper && setSearchFilterValues({ shipperOrganisationId: searchedShipper.id });
      if (!showDiscoverBuyRates) {
        setStateUtil({ activeKey: 'SELL' });
      }
      if (!history?.location?.state?.fromPopUp && searchFilters.viewType === GridView.GRID) {
        fetchFiltersAndGridData();
      }
    }
  }, []);

  useEffect(() => {
    if (isLandingPage && mode) {
      getRecentSearches(mode);
    }
  }, [isLandingPage, mode]);

  useEffect(() => {
    if (selectedVendorRating.length) {
      const data: any[] = [];
      selectedVendorRating?.forEach((rating) => {
        for (let card of searchResults) {
          if (+rating && card?.ffOrganisation?.rating && card?.ffOrganisation?.rating === +rating) {
            data.push(card);
          } else if (rating === '0' && !card?.ffOrganisation?.rating) {
            data.push(card);
          }
        }
      });
      setStateUtil({searchResultsWithVendorRatingFilter: data})
    } else {
      setStateUtil({searchResultsWithVendorRatingFilter: []})
    }
  }, [selectedVendorRating])

  const getRecentSearches = async (mode) => {
    setStateUtil({ isRecentSearchesLoading: true });
    const response = await fetchRecentSearches({ mode });
    if (response.isSuccess) {
      setStateUtil({
        recentSearches: response.data,
        isRecentSearchesLoading: response.data?.length < 5,
      });
    }
    if (response.data?.length < 5 || !response.isSuccess) {
      const trendingSearchesResponse = await fetchTrendingSearches({ mode });
      if (trendingSearchesResponse.isSuccess) {
        setStateUtil({
          trendingSearches: trendingSearchesResponse.data,
          isRecentSearchesLoading: false,
        });
      } else {
        message.error(trendingSearchesResponse.errorMessage);
      }
    }
  };

  useEffect(() => {
    if (isEmpty(portList) && searchFilters.viewType === GridView.GRID && !isLandingPage) {
      if (isEmpty(gridPorts)) {
        fetchGridPorts();
      } else if (history?.location?.state?.fromPopUp) {
        fetchFiltersAndGridData();
      }
    }
  }, [searchFilters.viewType]);

  const fetchFiltersAndGridData = async () => {
    await fetchFilters();
    fetchGridData();
  };

  useEffect(() => {
    !isLandingPage &&
      searchFilters?.viewType === GridView.GRID &&
      setStateUtil({ activeKey: 'BUY' });
  }, [searchFilters?.view]);

  const isFilterDisabled = () => {
    if (searchFilters?.viewType === GridView.GRID && !isLandingPage) {
      return Object.keys(portList)?.some((key) => portList[key].isLoading);
    }
    return;
  };

  useEffect(() => {
    !isLandingPage && !isFilterDisabled() && !isFilterApplied() && setFiltersRangeForGrid();
  }, [isFilterDisabled()]);

  const setFiltersRangeForGrid = () => {
    let freightPrice;
    let transitDays;
    Object.keys(portList)?.forEach((key) => {
      if (isValidArray(portList[key]?.fetchedResultWithFilters)) {
        const freightRange: any = portList[key]?.data?.freightPrice;
        const transitDaysRange: any = portList[key]?.data?.transitDays;
        freightPrice = {
          min: !isEmpty(freightPrice)
            ? Math.min(freightPrice.min, freightRange.min)
            : freightRange.min,
          max: !isEmpty(freightPrice)
            ? Math.max(freightPrice.max, freightRange.max)
            : freightRange.max,
          currency: 'USD',
        };
        freightPrice = {
          ...freightPrice,
          min: Math.round(freightPrice.min),
          max: Math.round(freightPrice.max),
        };
        transitDays = {
          min: !isEmpty(transitDays)
            ? Math.min(transitDays.min, transitDaysRange.min)
            : transitDaysRange.min,
          max: !isEmpty(transitDays)
            ? Math.max(transitDays.max, transitDaysRange.max)
            : transitDaysRange.max,
        };
      }
    });
    setGridFiltersRange({
      freightPrice,
      transitDays,
      gridFreightRange: freightPrice,
      gridTransitRange: transitDays,
    });
  };

  const fetchGridPorts = async () => {
    const searchedPorts = JSON.parse(localStorage.getItem('searchedPorts') || '{}');
    let gridPortList = {};
    await fetchFilters();
    if (isEmpty(searchedPorts)) {
      const responses: any = await Promise.all([
        getPorts({
          queryString: '',
          codeList: gridPortCodeList.POLCodeList,
        }),
        getPorts({
          queryString: '',
          codeList: gridPortCodeList.PODCodeList,
        }),
      ]);
      responses.forEach((response, index) => {
        if (!response.isSuccess) {
          message.error(response.errorMessage);
        } else {
          index
            ? (gridPortList = {
              ...gridPortList,
              POD: response.data?.map((item) => JSON.stringify(item || '{}')),
              PODList: response.data,
            })
            : (gridPortList = {
              ...gridPortList,
              POL: response.data?.map((item) => JSON.stringify(item || '{}')),
              POLList: response.data,
            });
        }
      });
    } else {
      gridPortList = searchedPorts;
    }
    await setGridPorts(gridPortList);
    fetchGridData();
  };

  useEffect(() => {
    if (orgType === 'FF') searchShipper(debouncedSearchShipper);
    else fetchMyteams(debouncedSearchShipper);
  }, [debouncedSearchShipper]);

  useEffect(() => {
    searchStakeholder(debouncedSearchStakeholder);
  }, [debouncedSearchStakeholder]);

  useEffect(() => {
    searchCustomer(debouncedSearchCustomer);
  }, [debouncedSearchCustomer]);

  useEffect(() => {
    if (errorMessage) {
      message.error(errorMessage, 5);
    }
  }, [errorMessage]);

  useEffect(() => {
    // To call the fetch api on refresh or when the user comes from the url
    // and not when clicked on the search button
    if (!isLandingPage) {
      if (query.has('mode')) {
        handleQuerySearch();
      } else {
        !history?.location?.state?.fromPopUp && handleTabChange(activeKey);
        const state = { ...history.location.state };
        state.fromPopUp = false;
        history?.location?.state?.fromPopUp && history.replace({ ...history.location, state });
      }
    }
  }, [activeKey]);

  const handleQuerySearch = async () => {
    const queryObject: { [key: string]: string } = {};
    query.forEach((data, key) => (queryObject[key] = data));
    const {
      cargoType,
      productType,
      containerType,
      containerSize,
      podId,
      polId,
      ffId,
      carrierId,
      incoterm,
      movementType
    } = queryObject;
    const dataToSend = {
      cargo: { cargo: cargoType, product: productType },
      container: { type: containerType, size: containerSize },
      mode: InquiryModes.FCL,
      podId,
      polId,
      sortBy: 'totalPrice',
      sortByOrder: 'ASC',
      ...(searchUUID && { uuid: searchUUID }),
      view: 'BUY',
      ...((incoterm && movementType) && { incoterm, movementType })
    };
    await fetchAllData({customDataFromQuery: dataToSend});
    if (ffId) getAllDataSetFilter({ ffIdsList: [ffId] });
    if (carrierId) getAllDataSetFilter({ carrierList: [carrierId] });
  };

  const isGridView = () => {
    return showDiscoverBuyRates && searchFilters.viewType !== GridView.LIST && orgType === 'FF';
  };

  const handleTabChange = async (activeKey) => {
    !discoverRatesPrefillData ?  getAllDataResetFilter(false, false) : () => {};
    getAllDataSetSortByFilter({ sortBy: 'totalPrice' }, false);
    !redirectToLandingPage && history.push(getDiscoverRatesRoute(activeKey.toLowerCase()));
    if (
      !isGridView() &&
      !location?.state?.rootTitle &&
      (activeKey === 'BUY' || form.getFieldValue('shipperOrganisationId'))
    ) {
      if (!isInitial) {
        setTimeout(async () => {
          await fetchAllData({fromURL: true, tabChange: true});
        }, 2000);
      }
    }
  };

  const searchShipper = async (queryString): Promise<void> => {
    setStateUtil({ fetchingShippers: true });
    const shippers = await fetchShippers(queryString);
    setStateUtil({
      linkedShippers: shippers,
      fetchingShippers: false,
    });
  };

  const fetchMyteams = async (teamName = "") => {
    setStateUtil({ fetchingShippers: true });
    const ffs = await fetchVendorsAndTeams({ fetchMyTeamsOnly: true, teamName }, state.teams, null);
    const { teams } = ffs;
    setStateUtil({ teams, fetchingShippers: false });
  };

  const searchStakeholder = async (queryString: string): Promise<void> => {
    setStateUtil({ fetchingStakeholders: true });
    try {
      const response = await fetchAllStakeholdersPaginated({
        stakeholderType: [StakeholderTypes.SHIPPER, StakeholderTypes.SUPPLIER],
        searchQuery: queryString || '',
        resultPerPage: 25,
        currentPageNumber: 1,
      });
      if (response.isSuccess) {
        const data = response.data?.data || [];
        const mapped = data.map((item: { org2Id: string; name: string }) => ({
          key: item.org2Id,
          label: item.name,
        }));
        setStateUtil({ stakeholderList: mapped, fetchingStakeholders: false });
      } else {
        setStateUtil({ stakeholderList: [], fetchingStakeholders: false });
      }
    } catch {
      setStateUtil({ stakeholderList: [], fetchingStakeholders: false });
    }
  };

  const searchCustomer = async (queryString: string): Promise<void> => {
    setStateUtil({ fetchingCustomers: true });
    try {
      const response = await fetchAllStakeholdersPaginated({
        stakeholderType: [StakeholderTypes.CUSTOMER],
        searchQuery: queryString || '',
        resultPerPage: 25,
        currentPageNumber: 1,
      });
      if (response.isSuccess) {
        const data = response.data?.data || [];
        const mapped = data.map((item: { org2Id: string; name: string }) => ({
          key: item.org2Id,
          label: item.name,
        }));
        setStateUtil({ customerList: mapped, fetchingCustomers: false });
      } else {
        setStateUtil({ customerList: [], fetchingCustomers: false });
      }
    } catch {
      setStateUtil({ customerList: [], fetchingCustomers: false });
    }
  };

  const isLocalsPresent =
    (isValidArray(searchResults) && searchResults.some((result) => result.totalLocalCharge)) ||
    isValidArray(selectedFilters.excludeLocalCategoryList);

  const setStateUtil = (newState: Partial<StateProps>) => {
    setState((oldState: StateProps) => {
      return {
        ...oldState,
        ...newState,
      };
    });
  };

  const renderAnalyticsView = (): React.ReactElement => {
    return (
      <div
        className={classes.listDiv}
        style={{ marginTop: '10px', maxHeight: isLocalsPresent ? '1102px' : '984px' }}
      >
        <AnalyticsView
        selectedVendorRating={selectedVendorRating}
        searchResultsWithVendorRatingFilter={searchResultsWithVendorRatingFilter}
        isLocalsPresent={isLocalsPresent}
        activeKey={activeKey}
        handleNewInquiry={handleNewInquiry}
        />
      </div>
    );
  };

  const renderChargeListCards = (): React.ReactElement => {
    const ffListMap = isValidArray(ffList) ? arrayToObject(ffList, 'id') : {};
    const topResult = sortBy(fetchedResultWithFilters, 'rank')?.[0];
    const cardsList = selectedVendorRating?.length ? searchResultsWithVendorRatingFilter : searchResults;
    if (!cardsList?.length) {
      return renderEmptyState()
    }
    return (
      <div
        style={{ marginTop: '10px', maxHeight: isLocalsPresent ? '1102px' : '984px' }}
        className={classes.listDiv}
        id="intersectDiv"
      >
        {cardsList?.map((item, index) => {
          const IntersectCard = (
            <IntersectChargeCard
              domSelector="intersectDiv"
              searchResult={item}
              topResult={topResult}
              key={item.freightChargeId}
              isItemPresent={{ isLocalsPresent, activeKey, ffListMap, handleNewInquiry, history }}
            />
          );
          // if (index === 3 && orgType === 'SHIPPER') {
          //   return (
          //     <React.Fragment>
          //       {IntersectCard}
          //       {renderSendInquiry()}
          //     </React.Fragment>
          //   );
          // }
          return IntersectCard;
        })}
        {/* {searchResults.length < 4 && orgType === 'SHIPPER' && renderSendInquiry()} */}
      </div>
    );
  };

  const renderVerticalChargeListCards = (): React.ReactElement => {
    const ffListMap = isValidArray(ffList) ? arrayToObject(ffList, 'id') : {};
    const topResult = sortBy(fetchedResultWithFilters, 'rank')?.[0];
    const cardsList = selectedVendorRating?.length ? searchResultsWithVendorRatingFilter : searchResults;
    
    if (!cardsList?.length) {
      return renderEmptyState();
    }
  
    return (
      <div className={classes.verticalScrollOuterContainer}>
        <div className={classes.verticalScrollWrapper}>
          <div 
            className={classes.verticalScrollContainer}
          >
            {cardsList.map((item) => (
              <div 
                key={item.freightChargeId || item.id} 
                className={classes.verticalScrollCardItem}
              >
                <ColumnViewIntersectChargeCard
                  classes={{ interSectDiv: '' }}
                  searchResult={item}
                  topResult={topResult}
                  isItemPresent={{ isLocalsPresent, activeKey, ffListMap, handleNewInquiry, history }}
                  searchFilters={searchFilters}
                  isGeneratingBookingData={false}
                  key={item.freightChargeId}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderSelectedSortBy = (): React.ReactElement => {
    const optionsToShow = isLocalsPresent ? sortByOptions : sortByWhenNoLocals[mode || InquiryModes.FCL];
    return (
      <span style={{ color: tokens.colors.primaryDark, fontWeight: 600 }}>
        <span style={{ marginRight: '5px' }}>
          {sortByFilters.sortByOrder === 'DESC' ? (
            <Icon type="arrow-down" />
          ) : (
            <Icon type="arrow-up" />
          )}
        </span>
        {optionsToShow[sortByFilters.sortBy]}
      </span>
    );
  };

  const renderSortBy = (showCustomisedRatesButton): React.ReactElement => {
    return (
      <div
        className={
          isCustomisedRatesSelected
            ? classNames(classes.sortByDiv, classes.disabledDiv)
            : classNames(classes.sortByDiv)
        }
        style={{ justifyContent: orgType === 'SHIPPER' ? 'flex-start' : 'flex-end' }}
      >
        {showCustomisedRatesButton && <span className={classes.sortByPartition}>|</span>}
        <span style={{ marginRight: '15px' }}>Sorted By:</span>
        <span onClick={() => handleSortByClick()} style={{ cursor: 'pointer' }}>
          {renderSelectedSortBy()}
          <Icon type="down" style={{ fontSize: '10px', marginLeft: '10px' }} />
        </span>
        {isSortByPopupVisible && (
          <DiscoverRateSortByPopup
            mode={mode}
            handleCloseFilters={handleCloseFilters}
            isLocalsPresent={isLocalsPresent}
            isLoading={isLoading}
            activeKey={activeKey}
          />
        )}
      </div>
    );
  };

  const handleSortByClick = (): void => {
    setStateUtil({ isSortByPopupVisible: !isSortByPopupVisible });
  };

  const handleCloseFilters = (): void => {
    setStateUtil({ isSortByPopupVisible: false });
  };

  const isCustomisedRatesSelected =
    isValidArray(selectedFilters?.organisationList) || selectedFilters.isBulkNegotiationOn;

  const handleGetCustomisedRates = async (): Promise<void> => {
    const { pol, pod, container, cargo, incoterm, movementType, mode, grossWeight, totalVolume,
      count = 1, length, breadth, height, dimensionUnit, totalVolumetricWeight } = searchFilters;
    const { originServices, destinationServices } = selectedFilters;
    const cargoList = JSON.parse(cargo || '[]');
    const body = {
      mode,
      pol: pol?.code,
      pod: pod?.code,
      container: {
        ...(mode === InquiryModes.FCL && JSON.parse(container || '[]')?.key),
        count: mode !== InquiryModes.FCL ? count : selectedFilters?.noOfContainers ?? 1,
        ...(length && {
          packageDimension: {
            height,
            breadth,
            length,
            unit: dimensionUnit,
          }
        }),
        ...(grossWeight && { weight: grossWeight }),
        ...(totalVolume && { volume: {...totalVolume, value: totalVolume.value / count}  }),
        ...(totalVolumetricWeight && { volumetricWeight: {...totalVolumetricWeight, value: totalVolumetricWeight.value / count}  })
      },
      cargoDetails: { cargo: cargoList?.key?.cargo, product: cargoList?.label?.product },
      incoterm, movementType,
      originServices, destinationServices,
    };
    setStateUtil({ fetchingCustomisedRates: true });
    const response = await fetchPreviousInquiries(body);
    if (response.isSuccess && isValidArray(response.data?.inquiries)) {
      setStateUtil({
        fetchingCustomisedRates: false,
        isInquiryConfirmationVisible: true,
        inquiryData: response.data.inquiries,
        searchParams: response.data.searchParams,
      });
    } else if (response.isSuccess) {
      handleNewInquiry(true);
    } else {
      message.error(response.errorMessage);
      setStateUtil({ fetchingCustomisedRates: false });
    }
  };

  const handleNewInquiry: (disableFields: boolean, sendInquiry?: boolean) => void = (
    disableFields,
    sendInquiry
  ) => {
    history.push(getCreateInquiryRoute(), { disableFields, from: 'discoverRates', sendInquiry });
  };

  // const renderBulkNegotiateButton = () => {
  //   const { isBulkNegotiationOn, organisationList } = selectedFilters;
  //   const orgList = selectedFilters.organisationList;
  //   return isBulkNegotiationOn ? (
  //     <div className={classes.bulkNegotiate}>
  //       <span style={{ color: '#333333' }}>
  //         {isValidArray(orgList)
  //           ? `${orgList.length} rates selected.`
  //           : 'Select rates & proceed to get customised rates.'}
  //       </span>
  //       <span
  //         className={classes.cancelButton}
  //         onClick={() => {
  //           getAllDataSetFilter(
  //             {
  //               organisationList: undefined,
  //               isBulkNegotiationOn: false,
  //             },
  //             false
  //           );
  //         }}
  //       >
  //         Cancel
  //       </span>
  //       <Button
  //         disabled={!isValidArray(organisationList)}
  //         className={
  //           isCustomisedRatesSelected
  //             ? classes.customisedRateButton
  //             : classes.disabledCustomisedButton
  //         }
  //         loading={fetchingCustomisedRates}
  //         onClick={() => handleGetCustomisedRates()}
  //       >
  //         Proceed
  //       </Button>
  //     </div>
  //   ) : (
  //     <Button
  //       className={classes.multipleNegotiateBtn}
  //       loading={fetchingCustomisedRates}
  //       onClick={() => {
  //         if (isDemoOrganisation()) {
  //           message.error(PERMISSON_ERROR_MESSAGE);
  //           return;
  //         }
  //         sendEvent(
  //           EventCategories.DISCOVER_RATES_NEGOTIATE_SHIPPER,
  //           'Negotiate on multiple rates - clicked'
  //         );
  //         getAllDataSetFilter(
  //           {
  //             isBulkNegotiationOn: true,
  //           },
  //           false
  //         );
  //       }}
  //     >
  //       Negotiate on Multiple Rates
  //     </Button>
  //   );
  // };

  const showNotificationSetting = () => {
    return (
      !searchResults?.length &&
      orgType === 'SHIPPER' &&
      props?.partsToShow?.[MY_PROFILE] &&
      props.notificationMasters.length
    );
  };

  const navigationToEmailNotification = () =>
    history.push('/account', { defaultActiveKey: 'notificationSettings' });

  const renderViewSelection = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%'}}>
        <span style={{fontSize: '12px', marginTop: '6px'}}>View: </span>
        <Select
          className={classes.transparentSelect}
          value={state.selectedView}
          onChange={(value) => setStateUtil({ selectedView: value })}
          dropdownMatchSelectWidth = {false}
          data-testid={'viewSelection'}
        >
          <Select.Option value={DiscoverRatesViews.RATES} key={DiscoverRatesViews.RATES}>
          {DiscoverRatesViews.RATES}
          </Select.Option>
          <Select.Option value={DiscoverRatesViews.ANALYTICS} key={DiscoverRatesViews.ANALYTICS}>
          {DiscoverRatesViews.ANALYTICS}
          </Select.Option>
          <Select.Option value={DiscoverRatesViews.RATES_IN_COLUMN} key={DiscoverRatesViews.RATES_IN_COLUMN}>
          {DiscoverRatesViews.RATES_IN_COLUMN}
          </Select.Option>
        </Select>
      </div>
    );
  };

  const renderPartition = () => {
    return <span style={{fontSize: '14px'}}>|</span>
  }

  const renderTotalResultsInfo = () => {
    const showCustomisedRatesButton = orgType === 'SHIPPER' && createInquiryPermission;
    const container = JSON.parse(searchFilters.container || '[]');
    const cargo = JSON.parse(searchFilters.cargo || '[]');
    return (
      <Row
        style={{
          width:
            isLocalsPresent ||
              isSellRatesContentVisible(buyRatesViewPermission, activeKey) ||
              showCustomisedRatesButton
              ? '96%'
              : '90%',
        }}
      >
        <Col span={showCustomisedRatesButton ? 13 : 21}>
          <div
            style={{
              marginTop: '20px',
              marginBottom: '4px',
              marginLeft: '5px',
              display: 'flex',
              alignItems: 'center',
              fontSize: '12px'
            }}
          >
            <div
            className={classes.viewSelectionDiv}>{renderViewSelection()}
            {renderPartition()}
            </div>
            <strong style={{ fontSize: '14px' }}>
              {selectedVendorRating?.length ? 
                searchResultsWithVendorRatingFilter?.length : 
                searchResults?.length || 0}
            </strong>&nbsp;Search Results{' '}
            {showNotificationSetting() && (
              <Col span={14} style={{ marginLeft: 4 }}>
                {renderPartition()}
                <Icon type="mail" style={{ fontSize: 12, marginLeft: 4 }} />
                <Button
                  type="link"
                  style={{ fontSize: 12, paddingLeft: 6 }}
                  onClick={navigationToEmailNotification}
                >
                  Email Notification Settings
                </Button>
              </Col>
            )}
            {orgType !== 'SHIPPER' && (
              <React.Fragment>
                for
                <span style={{ fontWeight: 600 }}>
                  &nbsp;
                  {searchFilters.pol?.code} - {searchFilters.pod?.code}
                  {renderPartition()}
                  {container?.label?.type}-{container?.label?.size}
                  {renderPartition()}
                  {cargo?.label?.cargo}-{cargo?.label?.product}
                </span>
              </React.Fragment>
            )}
            {orgType === 'SHIPPER' && searchResults?.length ? (
              <div style={{ margin: '-24px 0 0 10px ' }}>
                {renderSortBy(showCustomisedRatesButton)}
              </div>
            ) : (
              ''
            )}
          </div>
        </Col>
        {orgType !== 'SHIPPER' && (
          <Col span={6}>{searchResults?.length ? renderSortBy(showCustomisedRatesButton) : ''}</Col>
        )}
        {/* {showCustomisedRatesButton && showMarkupCriteria && (
          <Col span={14} className={classes.buttonsDiv}>
            {isValidArray(searchResults) && renderBulkNegotiateButton()}
          </Col>
        )} */}
      </Row>
    );
  };

  const renderEmptyState = (): React.ReactElement => {
    
    return (
      <React.Fragment>
        <div className={classes.emptyState}>
          <img src={emptyDiscoverRates} />
          <span className={classes.noResultText}>
            No rates found for this search & filter combination.
            <br />
            Try modifying your search.
          </span>
          {orgType === 'SHIPPER' && createInquiryPermission && showMarkupCriteria && !isValidArray(searchResults) && (
            <>  
              <p style={{margin: 12}}>-OR-</p>
              <Button
                className={classes.createInquiryButton}
                disabled={isCustomisedRatesSelected}
                onClick={() => handleNewInquiry(false)}
                size='large'
              >
                Create New Inquiry
              </Button>
            </>  
          )}
        </div>
      </React.Fragment>
    );
  };

  // const renderSendInquiry = (): React.ReactElement => {
  //   return (
  //     <Row className={classNames(classes.listDiv, classes.sendInquiryCard)} justify="space-between">
  //       <Col span={20} className={classes.sendInquiryLabel}>
  //         Need rates for specific shipping line, lower price or want more options from other FFs ?
  //       </Col>
  //       <Col
  //         className={classes.sendInquiryLabel}
  //         span={4}
  //         style={{ color: '#006EC3', cursor: 'pointer', fontWeight: 600 }}
  //       >
  //         <Button
  //           type="link"
  //           size="default"
  //           onClick={() => handleNewInquiry(true, true)}
  //           style={{
  //             display: 'flex',
  //             alignItems: 'center',
  //           }}
  //         >
  //           <span style={{ color: tokens.colors.primaryDark, fontWeight: 600 }}>Send Inquiry</span>
  //           <SendIcon style={arrowSvg} />
  //         </Button>
  //       </Col>
  //     </Row>
  //   );
  // };

  const renderPageContent = (): React.ReactElement => {
    return (
      <React.Fragment>
        {renderTotalResultsInfo()}
        {selectedView === DiscoverRatesViews.RATES && (renderChargeListCards())}
        {selectedView === DiscoverRatesViews.ANALYTICS && renderAnalyticsView()}
        {selectedView === DiscoverRatesViews.RATES_IN_COLUMN && (renderVerticalChargeListCards())}
      </React.Fragment>
    );
  };

  const handleShipperChange = (shipper) => {
    const shipperObj = {
      id: shipper.key,
      name: shipper.label,
      nonLinked: shipper.key === 'nonLinkedShippers',
    };
    window.localStorage.setItem('searchedShipper', JSON.stringify(shipperObj));
    setSearchFilterValues({ shipperOrganisationId: shipper.key });
    fetchAllData({tabChange: true});
  };

  const renderShipperSelect = (): React.ReactElement => {
    return (
      <div className={classes.flexRow}>
        <span className={classes.shipperTitle}>Shipper</span>
        <Form.Item style={{ marginBottom: 0 }}>
          {form.getFieldDecorator('shipperOrganisationId', {
            initialValue:
              searchedShipper?.id && searchedShipper?.name
                ? { key: searchedShipper.id, label: searchedShipper.name }
                : undefined,
          })(
            <Select
              mode="default"
              placeholder="Select Shipper"
              className={classes.shipperSelect}
              dropdownClassName={classes.dropdown}
              optionLabelProp="data-value"
              optionFilterProp="children"
              showSearch
              labelInValue
              onSearch={(val) => setStateUtil({ searchShipperQuery: val })}
              onChange={(val) => handleShipperChange(val)}
              dropdownRender={(menu) => renderSelectDropDown(menu, fetchingShippers)}
            >
              <Select.Option key="nonLinkedShippers" data-value="Non - Linked Shippers">
                Non - Linked Shippers <span className={classes.public}>Public View</span>
              </Select.Option>
              {isValidArray(linkedShippers) &&
                linkedShippers.map((shipper) => (
                  <Select.Option key={shipper.id} data-value={shipper.name}>
                    {shipper.name}
                  </Select.Option>
                ))}
            </Select>
          )}
        </Form.Item>
      </div>
    );
  };

  const renderSelectShipper = (): React.ReactElement => {
    return (
      <div className={classes.emptyShipperMessage}>
        <span style={{ color: '#666666' }}>
          Please select shipper for whom you want to see the sell rates.
        </span>
      </div>
    );
  };

  const getSellTabContent = (): React.ReactElement => {
    const shipperSelected = form.getFieldValue('shipperOrganisationId');
    return shipperSelected ? <div>{getTabContent()}</div> : renderSelectShipper();
  };

  const renderGridHeader = (): React.ReactElement => {
    return (
      <Row className={classes.gridOptions}>
        <Col span={2} style={{ borderLeft: `1px solid ${tokens.colors.border}`, paddingLeft: '5px' }}>
          <Icon type="arrow-down" style={{ marginRight: '5px' }} />
          POL
        </Col>
        <Col
          span={2}
          style={{ borderBottom: `1px solid ${tokens.colors.border}`, marginLeft: '4px', paddingBottom: '5px' }}
        >
          POD
          <Icon type="arrow-right" style={{ marginLeft: '5px' }} />
        </Col>
        <Col span={12} style={{ borderBottom: `1px solid ${tokens.colors.border}` }}></Col>
        <Col span={3} style={{ borderBottom: `1px solid ${tokens.colors.border}`, width: '10%', textAlign: 'end' }}>
          <span
            className={isFilterDisabled() ? classes.portSettingsDisabled : classes.portSettings}
            onClick={() => setStateUtil({ isPortSettingsVisible: true })}
          >
            <Icon type="setting" style={{ marginRight: '4px' }} />
            <span className={classes.portSettingsTitle}>Port Settings</span>
          </span>
        </Col>
        <Col
          span={6}
          style={{
            paddingLeft: '15px',
            borderBottom: `1px solid ${tokens.colors.border}`,
            width: '22%',
            textAlign: 'end',
          }}
        >
          <span>
            Refine By:{' '}
            <span
              style={{
                color: '#006EC3',
                fontSize: '12px',
              }}
            >
              Cheapest Freight Price
            </span>
          </span>
        </Col>
      </Row>
    );
  };

  const getStylesFromGridVerticalLength = () => {
    let fieldStyles = {
      gridBox: {
        height: 72, // need to calculate loader top position
        width: '76px',
      },
      noRates: {
        image: {
          height: '14px',
          width: '14px',
        },
        font: '8px',
        marginTop: '5px',
      },
      ratesCountLabel: '8px',
      carrierNameLabel: '10px',
    };
    if (PODList?.length <= 4) {
      fieldStyles = {
        gridBox: {
          height: 90,
          width: '103px',
        },
        noRates: {
          image: {
            height: '21px',
            width: '21px',
          },
          font: '12px',
          marginTop: '10px',
        },
        ratesCountLabel: '12px',
        carrierNameLabel: '15px',
      };
    }
    if (PODList?.length > 4 && PODList?.length <= 6) {
      fieldStyles = {
        gridBox: {
          height: 84,
          width: '94px',
        },
        noRates: {
          image: {
            height: '20px',
            width: '20px',
          },
          font: '10px',
          marginTop: '10px',
        },
        ratesCountLabel: '10px',
        carrierNameLabel: '14px',
      };
    }
    if (PODList?.length > 6 && PODList?.length <= 8) {
      fieldStyles = {
        gridBox: {
          height: 79,
          width: '85px',
        },
        noRates: {
          image: {
            height: '18px',
            width: '18px',
          },
          font: '8px',
          marginTop: '10px',
        },
        ratesCountLabel: '8px',
        carrierNameLabel: '12px',
      };
    }
    return fieldStyles;
  };

  const renderPortTooltipTitle = (item: PortOrLocation): React.ReactElement => {
    return (
      <React.Fragment>
        <div style={{ fontSize: '10px' }}>
          {item.name} ({item.code})
        </div>
        <div>
          <img className={classes.portFlag} src={item.flagS3Link || item.flag_s3_link} />
          <span style={{ fontSize: '10px', marginLeft: '4px' }}>{item.countryName}</span>
        </div>
      </React.Fragment>
    );
  };

  const renderPortContent = (item: PortOrLocation, pol = false): React.ReactElement => {
    return (
      <Tooltip
        mouseEnterDelay={0.3}
        title={renderPortTooltipTitle(item)}
        placement={pol ? 'topLeft' : 'top'}
      >
        <div
          className={classes.ellipses}
          style={{
            fontSize: '12px',
            color: '#111111',
          }}
        >
          {item.name}
        </div>
        <div>
          <img className={classes.portFlag} src={item.flagS3Link} />
          <span
            style={{
              fontSize: '10px',
              color: '#111111',
              marginLeft: '5px',
            }}
          >
            {item.countryCode}
          </span>
        </div>
      </Tooltip>
    );
  };

  const renderPODList = (): React.ReactElement => {
    const fieldStyles = getStylesFromGridVerticalLength();
    return (
      <div
        className={classes.flexRowDiv}
        style={{
          flex: '0 0 auto',
          zIndex: 10,
          backgroundColor: '#f5f4f2',
        }}
      >
        <div
          className={classes.stickyColumn}
          style={{
            borderLeft: `1px solid ${tokens.colors.border}`,
            ...(gridScrollLeft && {
              boxShadow: '4px 0 5px -2px rgba(0,0,0,0.1)',
            }),
          }}
        ></div>
        {PODList.map((item, index) => {
          const widthValue = Number(fieldStyles.gridBox.width.replace('px', ''));
          return (
            <div
              style={{
                width: `${widthValue - (PODList.length - 1 === index ? 8 : 0)}px`,
                flex: '0 0 auto',
                paddingTop: '5px',
                backgroundColor: '#f5f4f2',
                ...(gridScrollTop && {
                  boxShadow: '2px 2px 8px 0px rgba(0,0,0,0.1)',
                }),
                marginRight: '10px',
                height: '50px',
              }}
            >
              {renderPortContent(item)}
            </div>
          );
        })}
      </div>
    );
  };

  const SavedValues = JSON.parse(localStorage.getItem(savedInLocalStorage.SAVED_SEARCH) || '[]');

  const addToLocalStorage = (data): void => {
    const SavedArray = setSavedArray(data, SavedValues);
    window.localStorage.setItem(savedInLocalStorage.SAVED_SEARCH, JSON.stringify(SavedArray));
  };

  const isFilterApplied = () => {
    return (
      selectedFilters?.noOfContainers > 1 ||
      selectedFilters?.rateType?.length ||
      !!selectedFilters?.validityEnd ||
      selectedFilters?.route?.length ||
      ((selectedFilters?.transitDays?.min || selectedFilters?.transitDays?.min === 0) &&
        selectedFilters?.transitDays?.max) ||
      ((selectedFilters?.freightPrice?.min || selectedFilters?.freightPrice?.min === 0) &&
        selectedFilters?.freightPrice?.max) ||
      selectedFilters?.carrierList?.length
    );
  };

  const showListView = async (data) => {
    const { searchResults, pol, pod, viewType } = data;
    setSearchFilterValues({
      pol,
      pod,
      viewType,
      cargo: searchFilters.cargo,
      container: searchFilters.container,
      fromGridView: true,
    });
    const { container, cargo } = searchFilters;
    setSearchResults(searchResults);
    addToLocalStorage({
      pol,
      pod,
      container: JSON.parse(container),
      cargo: JSON.parse(cargo),
    });
    const isPrimary = !isFilterApplied();
    await fetchAllData({isSearch: isPrimary as boolean});
    await getAllDataSetFilter({ excludeLocalCategoryList: [] }, false);
  };

  const gridRowRef: any = React.useRef(null);

  const renderPOLList = (): React.ReactElement => {
    const fieldStyles = getStylesFromGridVerticalLength();
    return (
      <React.Fragment>
        {POLList.map((item) => {
          return (
            <div key={item.dbId} className={classes.flexRowDiv}>
              <div
                className={classNames(classes.flexColumn, classes.stickyColumn)}
                style={{
                  zIndex: 1,
                  paddingTop: '30px',
                  paddingLeft: '5px',
                  ...(gridScrollLeft && {
                    boxShadow: '4px 0 5px -2px rgba(0,0,0,0.1)',
                  }),
                  borderLeft: `1px solid ${tokens.colors.border}`,
                }}
              >
                {renderPortContent(item, true)}
              </div>
              {PODList.map((item2) => {
                return (
                  <GridBox
                    polPodPairData={portList[`${item.dbId}-${item2.dbId}`]}
                    fieldStyles={fieldStyles}
                    pol={item}
                    pod={item2}
                    showListView={showListView}
                  />
                );
              })}
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  const handleGridScroll = () => {
    setStateUtil({
      gridScrollTop: gridRowRef?.current?.scrollTop,
      gridScrollLeft: gridRowRef?.current?.scrollLeft,
    });
  };
  const debounceGridScroll = debounce(handleGridScroll, 100);

  const renderGridContent = (): React.ReactElement => {
    if (!POLList?.length || !PODList?.length) {
      return <Loader zIndex={1} top={200} />;
    }
    return (
      <React.Fragment>
        {renderGridHeader()}
        <div
          className={classes.gridContentWrapper}
          ref={gridRowRef}
          onScroll={() => debounceGridScroll()}
        // style={{
        //   maxHeight: filtersDivRef?.current?.clientHeight - 25,
        // }}
        >
          {renderPODList()}
          {renderPOLList()}
        </div>
      </React.Fragment>
    );
  };

  const getDisabledOpacity = () => {
    if (isFilterDisabled()) return 0.6;
    if (isCustomisedRatesSelected) return 0.3;
    return 1;
  };

  const filtersDivRef: any = React.useRef(null);
  const getTabContent = () => {
    return isFiltersLoading ? (
      <Loader zIndex={1} />
    ) : (
      <div style={{ backgroundColor: '#F5F4F2', paddingBottom: '50px', position: 'relative' }}>
        <div style={{ display: 'flex', position: 'relative', width: '100%' }}>
          <div 
            style={{
              width: isFilterCollapsed ? '0' : '260px',
              minWidth: isFilterCollapsed ? '0' : '260px',
              transition: 'all 0.3s ease',
              overflow: 'hidden',
              opacity: isCustomisedRatesSelected || isFilterDisabled() ? 0.6 : 1,
              backgroundColor: '#F5F4F2',
              padding: '16px 0 0 24px',
              flexShrink: 0
            }}
            className={isCustomisedRatesSelected || isFilterDisabled() ? classes.disabledDiv : undefined}
          >
            <div ref={filtersDivRef}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '16px',
                paddingRight: '16px'
              }}>
                <span style={{ fontWeight: 600, fontSize: '14px' }}></span>
                <Icon 
                  type="double-left" 
                  onClick={toggleFilterCollapse} 
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                />
              </div>
              <DiscoverRatesFilters 
                activeKey={activeKey} 
                isLocalsPresent={isLocalsPresent} 
                mode={mode} 
                setVendorRatingFilter={(selectedVendorRating: string[]) => setStateUtil({selectedVendorRating})}
                selectedVendorRating={selectedVendorRating}
                teams={teams}
                fetchingShippers={fetchingShippers}
                onSearchShipper={(query: string) => setStateUtil({ searchShipperQuery: query })}
                stakeholderList={stakeholderList}
                customerList={customerList}
                fetchingStakeholders={fetchingStakeholders}
                fetchingCustomers={fetchingCustomers}
                onSearchStakeholder={(query: string) => setStateUtil({ searchStakeholderQuery: query })}
                onSearchCustomer={(query: string) => setStateUtil({ searchCustomerQuery: query })}
              />
            </div>
          </div>

          <div 
            style={{
              flex: 1,
              position: 'relative',
              padding: '16px 24px 0 24px',
              transition: 'all 0.3s ease',
              backgroundColor: '#F5F4F2',
              minHeight: 'calc(100vh - 200px)',
              overflowX: 'hidden',
              overflowY: 'auto'
            }}
          >

            {isFilterCollapsed && (
              <div 
                style={{
                  position: 'fixed',
                  left: '0',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: '#ffffff',
                  boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.08)',
                  borderRadius: '0 8px 8px 0',
                  overflow: 'hidden',
                  zIndex: 10,
                  border: '1px solid #f0f0f0',
                  borderLeft: 'none',
                  transition: 'all 0.2s ease'
                }}
              >
                <div 
                  onClick={toggleFilterCollapse}
                  style={{
                    width: '20px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    borderTop: '1px solid #f0f0f0',
                    backgroundColor: '#fafafa',
                    padding: '0 2px',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Icon type="right" style={{ 
                    fontSize: '12px', 
                    color: '#8c8c8c',
                    transition: 'all 0.2s ease'
                  }} />
                </div>
              </div>
            )}

            {isLoading ? (
              <Loader zIndex={1} top={200} />
            ) : searchFilters?.viewType === GridView.GRID ? (
              renderGridContent()
            ) : (
              <div style={{ width: '100%', overflowX: 'visible' }}>
                {renderPageContent()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderViewTabs = () => {
    return (
      <Tabs
        className={classes.viewTabs}
        defaultActiveKey={activeKey}
        tabBarExtraContent={activeKey === 'SELL' && renderShipperSelect()}
        onChange={(activeKey) => {
          setStateUtil({ activeKey });
          setSearchFilterValues({ view: activeKey });
        }}
      >
        {showDiscoverBuyRates && buyRatesViewPermission && (
          <Tabs.TabPane tab="Buy & FAK Rates" key="BUY">
            {getTabContent()}
          </Tabs.TabPane>
        )}
        {showDiscoverSellRates &&
          sellRatesViewPermission &&
          searchFilters?.viewType !== GridView.GRID && (
            <Tabs.TabPane tab="Sell Rates" key="SELL">
              {getSellTabContent()}
            </Tabs.TabPane>
          )}
      </Tabs>
    );
  };

  const handleModeChange = (mode: string) => setStateUtil({ mode })

  const renderSpotSearches = () => {
    return (
      <React.Fragment>
        <div
          className={
            isCustomisedRatesSelected || isFilterDisabled()
              ? classNames(classes.searchBackground, classes.disabledDiv)
              : classNames(classes.searchBackground)
          }
          style={{ opacity: getDisabledOpacity() }}
        >
          <DiscoverRateSearchBar 
            key={uniqueKey} 
            isDiscoverPage={true} 
            setMode={handleModeChange} 
            shipperTeamId={form.getFieldValue('myTeam')}
            setIntial={() => setStateUtil({isInitial: false})}
            showRoadInsteadDomestic={showRoadInsteadDomestic}
          />
        </div>
        {orgType === 'FF' ? renderViewTabs() : getTabContent()}
        {isInquiryConfirmationVisible && (
          <InquiryConfirmationModal
            isVisible={isInquiryConfirmationVisible}
            inquiryData={inquiryData}
            searchParams={searchParams}
            onOk={() => handleNewInquiry(true)}
            onConfirmationClose={() => {
              getAllDataSetFilter(
                {
                  organisationList: undefined,
                  isBulkNegotiationOn: false,
                },
                false
              );
              setStateUtil({
                isInquiryConfirmationVisible: false,
                inquiryData: [],
                searchParams: undefined,
              });
            }}
          />
        )}
        {isPortSettingsVisible && (
          <PortSettingsSideDrawer
            isVisible={isPortSettingsVisible}
            onClose={(success = false) => {
              setStateUtil({ isPortSettingsVisible: false });
              success && fetchGridData(true);
            }}
          />
        )}
      </React.Fragment>
    );
  };

  const renderRecentSearches = (): React.ReactElement => {
    return (
      <React.Fragment>
        <div className={classes.shipmentDetails} style={{ margin: '0 0 15px 0' }}>
          Your Past Searches
        </div>
        {recentSearches?.map((search, index) => (
          <RecentOrTrendingCard mode={mode} key={index} cardData={search} history={history} />
        ))}
      </React.Fragment>
    );
  };

  const renderTrendingSearches = (): React.ReactElement => {
    return (
      <React.Fragment>
        <div className={classes.shipmentDetails} style={{ margin: '0 0 15px 0' }}>
          Trending Searches
        </div>
        {trendingSearches?.map((search, index) => (
          <RecentOrTrendingCard mode={mode} key={index} cardData={search} history={history} />
        ))}
      </React.Fragment>
    );
  };

  const renderLandingPage = (): React.ReactElement => {
    return (
      <Row style={{ color: tokens.colors.textSecondary, height: window.innerHeight }}>
        <Col span={9} className={classes.searchBar}>
          <div className={classes.shipmentDetails}>Shipment Details</div>
          <DiscoverRateSearchBar 
            key={uniqueKey} 
            setMode={handleModeChange} 
            setIntial={() => setStateUtil({isInitial: false})}
            showRoadInsteadDomestic={showRoadInsteadDomestic}
          />
        </Col>
        <Col span={15} className={classes.trendingSearches}>
          {isRecentSearchesLoading ? (
            <Loader zIndex={1} />
          ) : recentSearches.length >= 5 ? (
            renderRecentSearches()
          ) : (
            renderTrendingSearches()
          )}
        </Col>
      </Row>
    );
  };

  return (
    <div style={{ minWidth: MIN_WIDTH, backgroundColor: '#F5F4F2' }}>
      <Navbar pageTitle="Contract Rates" shouldDisplayBack={false} />
     {isLandingPage ? renderLandingPage() : renderSpotSearches()}
    </div>
  );
};

const mapStateToProps = ({ masterData, discoverRatesReducer, authUser }, ownProps) => ({
  isLoading: discoverRatesReducer.isLoading,
  isFiltersLoading: discoverRatesReducer.isFiltersLoading,
  searchResults: discoverRatesReducer.searchResults,
  fetchedResultWithFilters: discoverRatesReducer.fetchedResultWithFilters,
  searchFilters: discoverRatesReducer.searchFilters,
  selectedFilters: discoverRatesReducer.selectedFilters,
  sortByFilters: discoverRatesReducer.sortByFilters,
  buyRatesViewPermission: masterData.permissions.DISCOVER_BUY_RATES_VIEW,
  sellRatesViewPermission: masterData.permissions.DISCOVER_SELL_RATES_VIEW,
  showDiscoverSellRates: masterData.modules.show_discover_sell_rates,
  showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
  showMarkupCriteria: masterData?.modules?.show_markup_criteria,
  orgType: masterData.userData.type,
  userRole: masterData.userData.role,
  ffList: discoverRatesReducer.ffList,
  errorMessage: discoverRatesReducer.errorMessage,
  createInquiryPermission: masterData.permissions.INQUIRY_ALL_ACTIONS,
  gridPorts: discoverRatesReducer.gridPorts,
  portList: discoverRatesReducer.portList,
  uuid: discoverRatesReducer.uuid,
  partsToShow: authUser.partsToShow,
  notificationMasters: masterData?.modules?.show_notification_masters ?? [],
  discoverRatesPrefillData: masterData?.redirectPrefillData,
  showRoadInsteadDomestic: masterData?.modules?.show_road_instead_of_domestic
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAllDataResetFilter,
      setSearchFilterValues,
      fetchAllData,
      getAllDataSetFilter,
      getAllDataSetSortByFilter,
      fetchGridData,
      fetchFilters,
      setGridPorts,
      setGridFiltersRange,
      setSearchResults,
    },
    dispatch
  );
};

const DiscoverRatePageStyled = withStyles(DiscoverRatesStyles)(Form.create()(DiscoverRatePage));
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withAuthAccessExim([DISCOVER_SELL_RATES, DISCOVER_BUY_RATES, DISCOVER_RATES])(
    DiscoverRatePageStyled
  )
);
